// Stone, metal and glow materials for the Sagrada Família.
import { M } from '../lib/factory.js';
import { slats } from '../textures/windows.js';

// ---------- materials ----------
export const stoneOld = M(0xb09574),
  stoneNew = M(0xd8c9ad),
  stoneMid = M(0xcdbb9b),
  roofStone = M(0xbcab8e);
export const towerOld = M(0xb09574, { map: slats }),
  towerNew = M(0xdccdb2, { map: slats });
export const mGold = M(0xe3a92b, { roughness: 0.35, metalness: 0.2 }),
  mRed = M(0xc8392e, { roughness: 0.4 }),
  mWhite = M(0xf4efe4, { roughness: 0.35 });
export const crossMat = M(0xf6f3ec, {
  roughness: 0.25,
  metalness: 0.1,
  emissive: 0xfff3d6,
  emissiveIntensity: 0,
});
export const fruitMats = [0xe2533b, 0xf2b33d, 0x7fb04a, 0xc2408a, 0xf07e2c].map((c) =>
  M(c, { roughness: 0.4 }),
);
export const glowMats = [stoneOld, stoneNew, stoneMid, roofStone, towerOld, towerNew];
